import axios from '../axios'
import {
    CONTEST_LIST_REQUEST, CONTEST_LIST_SUCCESS, CONTEST_LIST_FAIL,
    CONTEST_DETAILS_REQUEST, CONTEST_DETAILS_SUCCESS, CONTEST_DETAILS_FAIL,
    CONTEST_CREATE_REQUEST, CONTEST_CREATE_SUCCESS, CONTEST_CREATE_FAIL,
    CONTEST_UPDATE_REQUEST, CONTEST_UPDATE_SUCCESS, CONTEST_UPDATE_FAIL,
    CONTEST_DELETE_REQUEST, CONTEST_DELETE_SUCCESS, CONTEST_DELETE_FAIL,
} from '../constants/contestConstants'


const authHeader = (userInfo) => ({
    headers: { Authorization: `Bearer ${userInfo.token}` }
})

const multipartHeader = (userInfo) => ({
    headers: {
        Authorization: `Bearer ${userInfo.token}`,
        'Content-Type': 'multipart/form-data',
    }
})


export const listContests = () => async (dispatch, getState) => {
    try {
        dispatch({ type: CONTEST_LIST_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.get('/api/contests/', authHeader(userInfo))
        dispatch({ type: CONTEST_LIST_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: CONTEST_LIST_FAIL, payload: error.response?.data?.detail || error.message })
    }
}


export const getContestDetails = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: CONTEST_DETAILS_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.get(`/api/contests/${id}/`, authHeader(userInfo))
        dispatch({ type: CONTEST_DETAILS_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: CONTEST_DETAILS_FAIL, payload: error.response?.data?.detail || error.message })
    }
}


export const createContest = (formData) => async (dispatch, getState) => {
    try {
        dispatch({ type: CONTEST_CREATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.post('/api/contests/create/', formData, multipartHeader(userInfo))
        dispatch({ type: CONTEST_CREATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: CONTEST_CREATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}


export const updateContest = (id, formData) => async (dispatch, getState) => {
    try {
        dispatch({ type: CONTEST_UPDATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.put(`/api/contests/update/${id}/`, formData, multipartHeader(userInfo))
        dispatch({ type: CONTEST_UPDATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: CONTEST_UPDATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}


export const deleteContest = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: CONTEST_DELETE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        await axios.delete(`/api/contests/delete/${id}/`, authHeader(userInfo))
        dispatch({ type: CONTEST_DELETE_SUCCESS })
    } catch (error) {
        dispatch({ type: CONTEST_DELETE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}
